import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Hr as Component } from './hr';
import type { IDeps, TProps } from './models';
import styles from './styles/styles.css';

export const Hr = createWidget<IDeps, TProps>({
    styles,
})(Component);
